import Warning from "@mui/icons-material/Warning";
import { SxProps, Tooltip, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface WarningIconProps {
  tip: NonNullable<ReactNode>;
  sx?: SxProps;
}

const WarningIcon = ({ tip, sx }: WarningIconProps) => {
  const {
    palette: { warning },
  } = useTheme();
  return (
    <Tooltip title={tip}>
      <Warning
        sx={{
          color: warning.main,
          fontSize: "24px",
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default WarningIcon;
